// phonics_data_lt20.js
// Letter Teams L20 - L20 Long Vowel Sounds ou, ow
// 路由：/phonics/lt20

const MEDIA_BASE = '/media/phonics/lt20';
const V = 'v1';

export const letterDataLt20 = {
  id: 'lt20',
  letter: 'L20',
  title: 'L20 Long Vowel Sounds ou, ow',
  mediaBase: MEDIA_BASE,

  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals go out.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "They lie down on a hill.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Look at the clouds!", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "That one is a cow.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Wow! That is a big cow!", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "That one is a crown.", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "And that one is a mouse.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Blue points at a cloud.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "I see a house.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "There are lots of houses.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "Let's count the houses!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "One, two, three...", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Look! It's an owl!", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "One, two, three...", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "The owl makes sounds.", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "It makes lots of sounds.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "That owl is too loud.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Let's go home, now!", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
      ],
    },
  ],
};
